import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { CommonService } from '../shareModule/services/common.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { select } from '@ngrx/store';
import { selectDiscountData, loadDiscount } from '../shareModule/states/nearby';
import { CustomerService } from '../shareModule/services/customer.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-edit-booking-variables',
  templateUrl: './edit-booking-variables.component.html',
  styleUrl: './edit-booking-variables.component.scss',
})
export class EditBookingVariablesComponent implements OnInit, OnDestroy {
  @Input() categoryId: number | string;
  @Input() isType = false;
  @Input() typeOrCategoryData = null;
  @Input() filter: string = '';
  
  superGroups: any[] = [];
  groups: any[] = [];
  selectedGroup: any = null;
  selectedVariable: any = null;

  superGroupsTitle = '';
  groupsTitle = '';
  variablesTitle = '';
  subVariablesTitle = '';

  newGroupTitle = '';
  newGroupValue = null;
  newGroupMaxValue = null;
  newVariableTitle = '';
  newGroupDescr = ''
  newGroupDescr2 = ''
  newSubVariableAmount = { amount: null, isPercent: false };
  newSubVariableTitle = '';
  newSubVariableImage = { fileBlob: null, fileUrl: '' };
  imgUrl = environment.ImageUrl;
  loading = false;
  selectedSuperGroup = null;
  newSuperGroupTitle = '';
  newSuperGroupProximityRebateValue = null
  selectedBannerImage: File | null = null
  selectedBannerImageURL: string | null = null;

  // Estimator fields from discount
  estimatorTitle = 'Estimate';
  estimatorDescription = 'Review your selected group and variables before submitting.';
  discountData: any = null;
  showEstimatorSettings = false;
  private destroy$ = new Subject<void>();

  constructor(
    private auth: AuthServiceService,
    public commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private store: Store,
    private customerService: CustomerService,
  ) {}

  ngOnInit() {
    if (this.categoryId) {
      this.init();
    }
    this.loadDiscountData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadDiscountData() {
    if (this.filter) {
      // Dispatch action to load discount data if not already loaded
      this.store.dispatch(loadDiscount({ filter: this.filter }));
      
      this.store
        .pipe(
          select(selectDiscountData),
          takeUntil(this.destroy$)
        )
        .subscribe((discountData) => {
          if (discountData && discountData.filter === this.filter) {
            this.discountData = discountData;
            this.estimatorTitle = discountData.estimatorTitle || this.estimatorTitle;
            this.estimatorDescription = discountData.estimatorDescription || this.estimatorDescription;
            this.cdr.detectChanges();
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['categoryId'] || changes['isType']) {
      console.log('categoryId or isType changed', this.categoryId, this.isType);
      this.loadSuperGroups();
    }
    if (changes['filter'] && this.filter) {
      this.loadDiscountData();
    }
  }
  init() {
    this.loadSuperGroups();
    this.loadCustomData();
  }

  changeCategoryBookingProperty(key, value) {
    this.auth
      .changeCategoryBookingProperty(this.categoryId, key, value, this.isType)
      .subscribe({
        next: (data) => {
          this.toastr.success('updated :)');
        },
        error: (error) => {
          this.toastr.error(error.error.message);
        },
      });
  }

  async setNewSubVariableImage(event) {
    const file = event.target?.files;
    if (!file) {
      console.error('no files in event');
      return;
    }
    const [convertedFileUrl, fileBlob] =
      await this.commonService.convertImageToURL(event, 0);
    this.newSubVariableImage.fileBlob = fileBlob;
    this.newSubVariableImage.fileUrl = convertedFileUrl;

    console.log('file conveted');
  }

  deleteSuperGroup(g) {
    this.auth.deleteBookingVariableSuperGroup(g.id).subscribe({
      next: () => {
        this.toastr.success('removed');
        this.loadSuperGroups();
      },
      error: (error) => {
        this.toastr.error(error.error.message);
      },
    });
  }

  addToSubVar(subVar, value) {
    this.auth
      .updateBookingSubVariable(
        subVar.id,
        subVar.title,
        subVar.amount,
        subVar.isPercent,
        (subVar.order ?? 0) + value,
      )
      .subscribe({
        next: () => {
          this.toastr.success('changed');
          this.init();
        },
        error: (error) => {
          this.toastr.error(error.error.message);
        },
      });
  }
  addToSubGroup(group, value) {
    this.auth
      .updateBookingVariableGroup(
        group.id,
        group.title,
        group.value,
        (group.order ?? 0) + value,
      )
      .subscribe({
        next: () => {
          this.toastr.success('changed');
          this.init();
        },
        error: (error) => {
          this.toastr.error(error.error.message);
        },
      });
  }

  loadCustomData() {
    this.superGroupsTitle =
      this.typeOrCategoryData.bookingMoreInfos?.customSuperGroupsName;
    this.groupsTitle =
      this.typeOrCategoryData.bookingMoreInfos?.customGroupsName;
    this.variablesTitle =
      this.typeOrCategoryData.bookingMoreInfos?.customVariablesName;
    this.subVariablesTitle =
      this.typeOrCategoryData.bookingMoreInfos?.customSubVariablesName;
  }
  loadSuperGroups() {
    this.auth
      .getBookingVariableSuperGroupsByCategory(this.categoryId, this.isType)
      .subscribe({
        next: (data) => {
          this.superGroups = data.body;
          console.log('superGroups=', this.superGroups);
          this.selectedSuperGroup = this.superGroups.find(
            (sg) => sg?.id == this.selectedSuperGroup?.id,
          );
          this.loadGroups();
        },
      });
    this;
  }
  loadGroups() {
    if (!this.selectedSuperGroup) {
      console.log('selected super group is empty');
      return;
    }
    this.loading = true;
    this.groups = this.selectedSuperGroup.bookingVariableGroups || [];
    for (const g of this.groups) {
      g.bookingVariables = g.bookingVariables || [];
      g.bookingVariables.forEach(
        (v) => (v.bookingSubVariables = v.bookingSubVariables || []),
      );
    }
    console.log('groups=', this.groups);

    this.loading = false;
    this.selectedGroup = this.groups.find(
      (g) => g?.id == this.selectedGroup?.id,
    );
    this.selectedVariable = this.selectedGroup?.bookingVariables?.find(
      (v) => v?.id == this.selectedVariable?.id,
    );
    // this.toastr.success('Added!');
    this.cdr.detectChanges();

    // this.auth
    //   .getBookingVariableGroupsByCategory(this.categoryId, this.isType)
    //   .subscribe(
    //     (res: any) => {

    //     },
    //     (err: any) => {
    //       this.toastr.error(err.error.message);
    //       console.error(err);
    //       this.loading = false;
    //     },
    //   );
  }

  selectSuperGroup(s) {
    this.selectedSuperGroup = s;
    this.loadGroups();
  }
  selectGroupImage(event, g){
    console.log("selecting group image")
    event.preventDefault();
     event.stopPropagation(); this.commonService.clickButton('selectNewGroupImage-'+g.id)
  }

  setListView(g, value){
    this.auth
        .updateBookingVariableSuperGroup(g.id, g.title, g.proximityRebateValue, value).subscribe({
      next: ()=>{
        this.toastr.success("List view updated")
      },
      error: error =>{
        this.toastr.error(error.error.message)
      }
    })
  }

  setNewGroupImage(event, group){
    console.log("uploading group image")
    this.auth.setSubGroupImage(group.id, event.target.files[0])
    .subscribe({
      next: data=>{
        //this.refreshSuperGroup(this.selectedSuperGroup?.id)
        this.loadSuperGroups()
      },
      error: error =>{
        this.toastr.error(error.error.message)
      }
    })
  }

  cloneSubGroup(g){
    this.auth.cloneSubGroup(g).subscribe({
      next: ()=>{
        this.toastr.success("Clone successful");
        this.loadSuperGroups();
      },
      error: (error)=>{
        this.toastr.error(error.error.message)
      }
    })
  }

  selectGroup(g: any) {
    console.log({ g });
    this.selectedGroup = g;
    this.selectedVariable = null;
    this.loadSuperGroups();
  }

  selectVariable(v: any) {
    this.selectedVariable = v;
  }
  addSuperGroup() {
    if (!this.newSuperGroupTitle) return;
    this.auth
      .createBookingVariableSuperGroup(
        this.categoryId,
        this.newSuperGroupTitle,
        this.isType,
        this.newSuperGroupProximityRebateValue
      )
      .subscribe(
        (res: any) => {
          this.newSuperGroupTitle = '';
          this.newSuperGroupProximityRebateValue = null
          this.loadSuperGroups();
          this.toastr.success('Added');
        },
        (err) => {
          this.toastr.error(err.error.message);
          console.error(err);
        },
      );
  }

  startEditSuperGroup(superGroup: any) {
    if (superGroup._editing) {
      return;
    }
    superGroup._originalTitle = superGroup.title;
    superGroup._skipBlurSave = false;
    superGroup._editing = true;
  }

  handleSuperGroupBlur(superGroup: any) {
    if (superGroup?._skipBlurSave) {
      superGroup._skipBlurSave = false;
      return;
    }
    this.saveSuperGroup(superGroup);
  }

  saveSuperGroup(superGroup: any, event?: Event) {
    if (!superGroup) {
      return;
    }
    event?.preventDefault();
    // if (!superGroup._editing || superGroup._saving) {
    //   if (event) {
    //     superGroup._skipBlurSave = false;
    //   }
    //   return;
    // }

    const updatedTitle = (superGroup.title || '').trim();

    if (!updatedTitle) {
      this.toastr.error('Group title is required');
      superGroup.title = superGroup._originalTitle;
      superGroup._editing = false;
      superGroup._skipBlurSave = false;
      return;
    }

    // if (updatedTitle === superGroup._originalTitle) {
    //   superGroup._editing = false;
    //   superGroup._skipBlurSave = false;
    //   delete superGroup._originalTitle;
    //   return;
    // }

    superGroup.title = updatedTitle;
    superGroup._saving = true;
    this.auth
      .updateBookingVariableSuperGroup(superGroup.id, updatedTitle, superGroup.proximityRebateValue)
      .subscribe({
        next: () => {
          superGroup._saving = false;
          superGroup._editing = false;
          superGroup._skipBlurSave = false;
          delete superGroup._originalTitle;
          this.toastr.success('Updated');
          this.loadSuperGroups();
        },
        error: (err) => {
          console.error(err);
          superGroup._saving = false;
          superGroup._editing = false;
          superGroup._skipBlurSave = false;
          superGroup.title = superGroup._originalTitle;
          delete superGroup._originalTitle;
          this.toastr.error(err?.error?.message || 'Unable to update group');
        },
      });
  }
  async setBanner(event){
    [this.selectedBannerImageURL, this.selectedBannerImage, ] = await this.commonService.convertImageToURL(event, 0);
    this.setCategoryVariableBanner()
  }

  setCategoryVariableBanner(){
    this.auth.setCategoryVariableBanner( this.isType ? 'TYPE' : 'CATEGORY',   this.typeOrCategoryData?.categoryChildId || this.typeOrCategoryData.id, this.selectedBannerImage)
    .subscribe({
      next: ()=>{
        this.toastr.success("Changed");
        // if(this.selectedBannerImage){
          this.typeOrCategoryData.variablesBanner = this.selectedBannerImageURL;
        //}
      },
      error: error => this.toastr.error(error.error.message)
    })
  }


  addGroup() {
    if (!this.newGroupTitle) return;
    this.auth
      .createBookingVariableGroup(
        this.selectedSuperGroup.id,
        this.newGroupTitle,
        this.newGroupValue,
        this.newGroupMaxValue,
        this.newGroupDescr,
        this.newGroupDescr2
      )
      .subscribe(
        (res: any) => {
          this.newGroupTitle = '';
          this.newGroupDescr = ''
          this.newGroupDescr2 = '';
          this.newGroupValue = null;
          this.newGroupMaxValue = null;
          this.loadSuperGroups();
          this.toastr.success('Added');
        },
        (err) => {
          this.toastr.error(err.error.message);
          console.error(err);
        },
      );
  }

  editGroup(g: any) {
    if (g._editing) {
      return;
    }
    g._editing = true;
    g._originalTitle = g.title;
    g._originalValue = g.value;
    g._hasValueField = g.value !== null && g.value !== undefined;
    g._skipBlurSave = false;
  }
  handleGroupBlur(group: any, event?: FocusEvent) {
    if (group?._skipBlurSave) {
      group._skipBlurSave = false;
      return;
    }
    const relatedTarget = event?.relatedTarget as HTMLElement | null;
    if (
      relatedTarget &&
      relatedTarget.getAttribute('data-group-id') === String(group?.id) &&
      relatedTarget.classList.contains('group-input')
    ) {
      return;
    }
    this.saveGroup(group);
  }
  saveGroup(g: any, event?: Event) {
    if (!g) return;
    event?.preventDefault();
    if (!g._editing || g._saving) {
      if (event) {
        g._skipBlurSave = false;
      }
      return;
    }

    const updatedTitle = (g.title || '').trim();
    const hasValueField = g._hasValueField;
    let updatedValue: number | null | undefined = undefined;
    if (hasValueField) {
      if (g.value === null || g.value === undefined || g.value === '') {
        updatedValue = null;
      } else {
        const parsedValue = Number(g.value);
        if (Number.isNaN(parsedValue)) {
          this.toastr.error('Value must be a number');
          g._skipBlurSave = false;
          return;
        }
        updatedValue = parsedValue;
      }
    }
    if (!updatedTitle) {
      this.toastr.error('Group title is required');
      g.title = g._originalTitle;
      if (hasValueField) {
        g.value = g._originalValue;
      }
      g._editing = false;
      g._skipBlurSave = false;
      delete g._originalTitle;
      delete g._originalValue;
      delete g._hasValueField;
      return;
    }


    g.title = updatedTitle;
    if (hasValueField) {
      g.value = updatedValue;
    }
    g._saving = true;
    this.auth
      .updateBookingVariableGroup(
        g.id,
        updatedTitle,
        hasValueField ? updatedValue : undefined,
        g.order,
        g.maxValue,
        g.descr ?? '',
        g.descr2 ?? ''
      )
      .subscribe(
        () => {
          g._saving = false;
          g._editing = false;
          g._skipBlurSave = false;
          delete g._originalTitle;
          delete g._originalValue;
          delete g._hasValueField;
          this.toastr.success('Updated');
          this.loadSuperGroups();
        },
        (err) => {
          console.error(err);
          g._saving = false;
          g._editing = false;
          g._skipBlurSave = false;
          if (hasValueField) {
            g.value = g._originalValue;
          }
          g.title = g._originalTitle;
          delete g._originalTitle;
          delete g._originalValue;
          delete g._hasValueField;
          this.toastr.error(err?.error?.message || 'Unable to update group');
        },
      );
  }
  deleteGroup(g: any) {
    if (!confirm('Delete this group?')) return;
    this.auth.deleteBookingVariableGroup(g.id).subscribe(
      () => {
        this.loadSuperGroups();
        this.toastr.success('deleted');
      },
      (err) => {
        console.error(err);
        this.toastr.error(err.error.message);
      },
    );
  }

  addVariable() {
    if (!this.newVariableTitle || !this.selectedGroup) return;
    this.auth
      .createBookingVariable(this.selectedGroup.id, this.newVariableTitle)
      .subscribe(
        (res: any) => {
          this.newVariableTitle = '';
          this.loadSuperGroups();
          this.toastr.success('Added');
        },
        (err) => {
          this.toastr.error(err.error.message);
          console.error(err);
        },
      );
  }

  editVariable(v: any) {
    if (v._editing) {
      return;
    }
    v._editing = true;
    v._originalTitle = v.title;
    v._skipBlurSave = false;
  }
  handleVariableBlur(variable: any, event?: FocusEvent) {
    if (variable?._skipBlurSave) {
      variable._skipBlurSave = false;
      return;
    }
    const relatedTarget = event?.relatedTarget as HTMLElement | null;
    if (
      relatedTarget &&
      relatedTarget.getAttribute('data-variable-id') === String(variable?.id) &&
      (relatedTarget.classList.contains('variable-input') ||
        relatedTarget.classList.contains('variable-action'))
    ) {
      return;
    }
    this.saveVariable(variable);
  }
  saveVariable(v: any, event?: Event) {
    if (!v) {
      return;
    }
    event?.preventDefault();
    if (!v._editing || v._saving) {
      if (event) {
        v._skipBlurSave = false;
      }
      return;
    }
    const updatedTitle = (v.title || '').trim();
    if (!updatedTitle) {
      this.toastr.error('Variable title is required');
      v.title = v._originalTitle;
      v._editing = false;
      v._skipBlurSave = false;
      delete v._originalTitle;
      return;
    }
    if (updatedTitle === v._originalTitle) {
      v._editing = false;
      v._skipBlurSave = false;
      delete v._originalTitle;
      return;
    }
    v.title = updatedTitle;
    v._saving = true;
    this.auth.updateBookingVariable(v.id, updatedTitle).subscribe(
      () => {
        v._saving = false;
        v._editing = false;
        v._skipBlurSave = false;
        delete v._originalTitle;
        this.toastr.success('Updated');
        this.loadSuperGroups();
      },
      (err) => {
        console.error(err);
        v._saving = false;
        v._editing = false;
        v._skipBlurSave = false;
        v.title = v._originalTitle;
        delete v._originalTitle;
        this.toastr.error(err?.error?.message || 'Unable to update variable');
      },
    );
  }
  deleteVariable(v: any) {
    if (!confirm('Delete this variable?')) return;
    this.auth.deleteBookingVariable(v.id).subscribe(
      () => {
        this.loadSuperGroups();
        this.toastr.success('deleted');
      },
      (err) => {
        console.error(err);
        this.toastr.error(err.error.message);
      },
    );
  }

  addSubVariable() {
    if (!this.newSubVariableTitle || !this.selectedVariable) return;
    this.auth
      .createBookingSubVariable(
        this.selectedVariable.id,
        this.newSubVariableTitle,
        this.newSubVariableAmount.amount,
        this.newSubVariableAmount.isPercent,
        this.newSubVariableImage.fileBlob,
      )
      .subscribe(
        () => {
          this.newSubVariableTitle = '';
          this.newSubVariableAmount.amount = null;
          this.newSubVariableAmount.isPercent = false;
          this.newSubVariableImage.fileBlob = null;
          this.newSubVariableImage.fileUrl = '';
          this.loadSuperGroups();
          this.toastr.success('Added');
        },
        (err) => {
          console.error(err);
          this.toastr.error(err.error.message);
        },
      );
  }

  s = null
  refreshSuperGroup(g){
    this.saveSuperGroup(g)
  }
  editSubVariable(s: any) {
    this.s = s;
    if (s._editing) {
      return;
    }
    s._editing = true;
    s._skipBlurSave = false;
    s._originalTitle = s.title;
    s._originalAmount = s.amount;
    s._originalIsPercent = this.normalizeIsPercent(s.isPercent);
    s._hasAmountField = s.amount !== null && s.amount !== undefined;
    s.isPercent = this.normalizeIsPercent(s.isPercent);
  }
  handleSubVariableBlur(subVariable: any, event?: FocusEvent) {
    if (subVariable?._skipBlurSave) {
      subVariable._skipBlurSave = false;
      return;
    }
    const relatedTarget = event?.relatedTarget as HTMLElement | null;
    if (
      relatedTarget &&
      relatedTarget.getAttribute('data-sub-variable-id') ===
        String(subVariable?.id) &&
      (relatedTarget.classList.contains('sub-variable-input') ||
        relatedTarget.classList.contains('sub-variable-action'))
    ) {
      return;
    }
    this.saveSubVariable(subVariable);
  }
  saveSubVariable(s: any, event?: Event) {
    if (!s) {
      console.log('s is null!')
      return;
    }
    event?.preventDefault();
    if (!s._editing || s._saving) {
      if (event) {
        s._skipBlurSave = false;
      }
      return;
    }

    const updatedTitle = (s.title || '').trim();
    if (!updatedTitle) {
      this.toastr.error('Sub variable title is required');
      s.title = s._originalTitle;
      this.restoreSubVariableMeta(s);
      return;
    }

    const hasAmountField = s._hasAmountField;
    let updatedAmount: number | null | undefined = undefined;
    let updatedIsPercent: boolean | undefined = undefined;
    if (hasAmountField) {
      if (s.amount === null || s.amount === undefined || s.amount === '') {
        updatedAmount = null;
      } else {
        const parsedAmount = Number(s.amount);
        if (Number.isNaN(parsedAmount)) {
          this.toastr.error('Amount must be a number');
          s._skipBlurSave = false;
          return;
        }
        updatedAmount = parsedAmount;
      }
      updatedIsPercent = this.normalizeIsPercent(s.isPercent);
    }

    const titleChanged = updatedTitle !== s._originalTitle;
  
    const percentChanged =
      hasAmountField &&
      typeof updatedIsPercent === 'boolean' &&
      updatedIsPercent !== this.normalizeIsPercent(s._originalIsPercent);

    // if (!titleChanged &&  !percentChanged) {
    //   this.restoreSubVariableMeta(s);
    //   return;
    // }

    s.title = updatedTitle;
    if (hasAmountField) {
      s.amount = updatedAmount;
      s.isPercent = updatedIsPercent;
    }

    s._saving = true;
    this.auth
      .updateBookingSubVariable(
        s.id,
        updatedTitle,
        hasAmountField ? updatedAmount : undefined,
        hasAmountField ? updatedIsPercent : undefined,
        s.order
      )
      .subscribe(
        () => {
          s._saving = false;
          this.restoreSubVariableMeta(s, true);
          this.toastr.success('Updated');
          this.loadSuperGroups();
        },
        (err) => {
          console.error(err);
          s._saving = false;
          s.title = s._originalTitle;
          s.amount = s._originalAmount;
          s.isPercent = this.normalizeIsPercent(s._originalIsPercent);
          this.restoreSubVariableMeta(s);
          this.toastr.error(
            err?.error?.message || 'Unable to update sub-variable',
          );
        },
      );
  }
  deleteSubVariable(s: any) {
    if (!confirm('Delete this sub-variable?')) return;
    this.auth.deleteBookingSubVariable(s.id).subscribe(
      () => {
        this.loadSuperGroups();
        this.toastr.success('subvar deleted');
      },
      (err) => console.error(err),
    );
  }

  saveAll() {
    // naive implementation: iterate through groups/vars/subvars and call updates for any modified item
    (this.groups || []).forEach((g) => {
      if (g._editing === false) {
        /* already saved */
      }
    });
    // we already save on each edit; this button could be used to force-refresh
    this.loadSuperGroups();
  }

  private normalizeIsPercent(value: any): boolean {
    if (typeof value === 'string') {
      return value === '1' || value.toLowerCase() === 'true';
    }
    return Boolean(value);
  }

  private restoreSubVariableMeta(subVariable: any, keepUpdated = false) {
    subVariable._editing = false;
    subVariable._skipBlurSave = false;
    if (!keepUpdated) {
      subVariable.title = subVariable._originalTitle;
      subVariable.amount = subVariable._originalAmount;
      subVariable.isPercent = this.normalizeIsPercent(
        subVariable._originalIsPercent,
      );
    }
    delete subVariable._originalTitle;
    delete subVariable._originalAmount;
    delete subVariable._originalIsPercent;
    delete subVariable._hasAmountField;
  }

  saveEstimator() {
    if (!this.filter) {
      this.toastr.error('Filter is required');
      return;
    }
    const payload = {
      filter: this.filter,
      estimatorTitle: this.estimatorTitle,
      estimatorDescription: this.estimatorDescription,
      id: this.discountData?.id || null,
    };
    this.customerService.createDiscount(payload).subscribe({
      next: () => {
        this.toastr.success('Estimator settings updated');
      },
      error: (error) => {
        this.toastr.error(error.error?.message || 'Failed to update estimator settings');
      },
    });
  }
}
